import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { useDealActions, useDealIdSelector } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils/json-to-url-encoded";
import { NotificationHandlerType } from "./use-click-handler";

export function useEmailHook(): NotificationHandlerType {
  const { push } = useHistory();
  const currentDealId: number | undefined = useDealIdSelector();
  const { getDealAndStoreAction } = useDealActions();
  const { getEmailsPathName } = useNavigationHooks();

  return useCallback(async ({ components }: INotification) => {
    // Without a mail_id we can't build a valid emails path, so bail out instead of
    // navigating to a broken URL like /deal/10/emails/undefined.
    if (components.mail_id == null) {
      return;
    }

    const searchObj: UrlQueryParams = {};
    if (currentDealId === components.deal_id) {
      await getDealAndStoreAction(components.deal_id);
    }
    searchObj.emailBox = components.mail_id;
    searchObj.section = components.section_id;

    push({
      pathname: getEmailsPathName(components.deal_id, components.mail_id),
      search: JSON_to_URLEncoded(searchObj)
    });
  }, []);
}
